import type { WorkforceWorkerDto } from '@artic/api-client';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { WorkerDetail } from '../../features/workforce/worker-detail';

export const Route = createFileRoute('/workforce/$workerId')({
  staticData: {
    breadcrumb: (match, client) => {
      const { workerId } = match.params as { workerId: string };
      const entries = client.getQueriesData<{ data?: WorkforceWorkerDto }>({
        predicate: (query) =>
          typeof query.queryKey[0] === 'string' &&
          query.queryKey[0].endsWith(`/workers/${workerId}`),
      });
      return (
        entries.find(([, response]) => response?.data?.worker_id === workerId)?.[1]?.data
          ?.worker_name ?? null
      );
    },
  },
  component: WorkerPage,
});

function WorkerPage() {
  const { workerId } = Route.useParams();
  const partnerId = usePartnerId();
  const { t } = useTranslation('workforce');
  return partnerId ? (
    <WorkerDetail key={`${partnerId}:${workerId}`} partnerId={partnerId} workerId={workerId} />
  ) : (
    <p className="p-6">{t('choosePartner')}</p>
  );
}
